module.exports = "/assets/restaurant-placeholder.png?Fb9b5iA";